import { LegalPage } from "../components/LegalPage";

const { Section } = LegalPage;

export default function Cookie() {
  return (
    <LegalPage title="Cookie Policy" updated="Giugno 2026">
      <p>
        La presente Cookie Policy illustra l'utilizzo dei cookie e delle tecnologie analoghe da parte
        della piattaforma <strong>Agenda-ISF-COMO</strong>.
      </p>

      <Section n="1" title="Cosa sono i cookie">
        <p>
          I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente,
          dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.
        </p>
      </Section>

      <Section n="2" title="Cookie tecnici necessari">
        <p>
          La Piattaforma utilizza esclusivamente <strong>cookie tecnici necessari</strong> al
          funzionamento del servizio, in particolare:
        </p>
        <ul className="list-disc space-y-1 pl-6">
          <li><strong>Cookie di autenticazione</strong> (token di sessione): consentono di mantenere l'utente autenticato in modo sicuro durante la navigazione;</li>
          <li><strong>Cookie di sessione</strong>: garantiscono il corretto funzionamento delle pagine e delle funzionalità.</li>
        </ul>
        <p>
          Questi cookie sono indispensabili e non richiedono consenso preventivo in quanto strettamente
          funzionali all'erogazione del servizio esplicitamente richiesto dall'utente.
        </p>
      </Section>

      <Section n="3" title="Cookie di profilazione e di terze parti">
        <p>
          La Piattaforma <strong>non</strong> utilizza cookie di profilazione né cookie di terze parti
          a fini pubblicitari o di marketing.
        </p>
      </Section>

      <Section n="4" title="Gestione dei cookie">
        <p>
          L'utente può gestire o disabilitare i cookie tramite le impostazioni del proprio browser. Si
          segnala che la disabilitazione dei cookie tecnici necessari può compromettere il corretto
          funzionamento della Piattaforma, impedendo in particolare l'accesso all'area riservata.
        </p>
      </Section>

      <Section n="5" title="Aggiornamenti">
        <p>
          La presente Cookie Policy può essere soggetta a modifiche. Si invita l'utente a consultarla
          periodicamente. Per ulteriori informazioni sul trattamento dei dati si rimanda alla Privacy
          Policy.
        </p>
      </Section>
    </LegalPage>
  );
}
